export enum CURRENCY {
  CHF = 'CHF',
  CZK = 'CZK',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  NOK = 'NOK',
  PLN = 'Zł',
  USD = 'USD',
}
